var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.273,
    height: 19.675,
    viewBox: "0 0 17.273 19.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-filter",
    transform: "translate(15874.35 23329.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M 7.657 19.675 a 2.661 2.661 0 0 1 -1.284 -0.333 a 2.493 2.493 0 0 1 -1.3 -2.2 v -4.9 a 2.9 2.9 0 0 0 -0.591 -1.506 L 1.025 7.085 A 3.707 3.707 0 0 1 0 4.757 V 2.633 A 2.56 2.56 0 0 1 2.54 0 H 14.733 a 2.539 2.539 0 0 1 2.54 2.54 V 4.572 a 4.157 4.157 0 0 1 -1.127 2.614 l -4 3.538 a 2.327 2.327 0 0 0 -0.693 1.607 V 16.3 a 2.736 2.736 0 0 1 -1.164 2.161 l -1.275 0.822 A 2.568 2.568 0 0 1 7.657 19.675 Z Z",
    transform: "translate(-15874.35 -23329.65)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterActive);
export default __webpack_public_path__ + "static/media/Icon-filter-active.364c5030095efdb7dd87a2d92b6f075c.svg";
export { ForwardRef as ReactComponent };